import { Component, OnInit, Input, ElementRef, OnDestroy } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { EntradasService } from 'src/app/modules/venta';
import { mergeMap, takeWhile, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { MotivosService } from 'src/app/modules/venta/services/motivos.service';
import { FormControlService } from 'src/app/shared/services/form-control.service';
import { MotivoPadService } from 'src/app/shared/services/motivo-pad.service';
import { Entrada } from 'src/app/modules/venta/models/entrada.model';
import { NumpadService } from 'src/app/shared/services/numpad.service';
import { ConfigurationService } from 'src/app/core';
import { ErrorToast } from 'src/app/core/toast/error.toast';
import { ToastrService } from 'ngx-toastr';
import { LocalizadorService } from '../../services/localizador.service';
import { TranslateService } from '../../../../shared/services/translate.service';

@Component({
  selector: 'ticketing-motivos-localizador',
  templateUrl: './motivos-localizador.component.html',
  styleUrls: ['./motivos-localizador.component.scss']
})
export class MotivosLocalizadorComponent implements OnInit, OnDestroy {
  @Input() entradas: any[];
  @Input() id: string;

  private element: any;

  currentEntrada;
  motivos;
  listaMotivosSeleccionados;
  motivoSeleccionado;

  configuracionDivisas;

  private alive = true;

  constructor(
    private modalService: ModalService,
    private entradaService: EntradasService,
    private motivosService: MotivosService,
    private el: ElementRef,
    private formControlService: FormControlService,
    private motivoPadService: MotivoPadService,
    private numpadService: NumpadService,
    private configuration: ConfigurationService,
    private toast: ToastrService,
    private localizadorService: LocalizadorService,
    private translate: TranslateService
  ) {
    this.element = el.nativeElement;
  }

  ngOnInit() {
    const modal = this;
    if (!this.id) {
      return;
    }
    document.body.appendChild(this.element);
    this.element.addEventListener('click', function(e: any) {
      if (e.target.className === 'jw-modal') {
        modal.close();
      }
    });
    this.modalService.add(this);
    
    // Suscribirse a cambios en el FormControl para configurar el motivo cuando sea necesario
    this.formControlService.currentFormGroup
      .pipe(takeWhile(() => this.alive))
      .subscribe((formGroup) => {
        if (formGroup && formGroup.tipo === 'MOTIVO' && formGroup.elemento) {
          // Si el tipo es MOTIVO pero motivoPadService.motivo no está configurado, intentar obtenerlo
          if (!this.motivoPadService.motivo) {
            const motivo = this.obtenerMotivoDesdeElemento(formGroup.elemento);
            if (motivo) {
              this.motivoPadService.motivo = motivo;
              console.log('[MOTIVOS-GESTIONAR-PAUSADAS] Motivo configurado desde FormControl observable:', motivo);
            }
          }
        }
      });
  }
  
  // Método auxiliar para obtener el motivo desde el elemento
  private obtenerMotivoDesdeElemento(elemento: HTMLElement): any {
    const motivoPkId = elemento.getAttribute('data-motivo-pk-id');
    if (motivoPkId) {
      const motivo = this.listaMotivosSeleccionados?.find(m => m.PkId === motivoPkId);
      if (motivo) {
        return motivo;
      }
    }
    // Fallback: buscar por id
    const id = elemento.id;
    if (id && id.startsWith('motivo-')) {
      const pkId = id.replace('motivo-', '');
      return this.listaMotivosSeleccionados?.find(m => m.PkId === pkId);
    }
    return null;
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  open(): void {
    this.configuracionDivisas = this.configuration.divisasValue[0];
    this.currentEntrada = this.entradas[0];
    this.entradaService.setEntradaSeleccionada(this.currentEntrada.entrada);
    this.entradaService.entradaSeleccionada$
      .pipe(
        mergeMap(entrada => {
          this.currentEntrada.entrada = entrada;
          if (entrada) {
            //<< Yaribel 20210504  Se ha modificado el codigo para indicar GrupoMotivoId tanto en entradas como en promociones y solo tiene valor si tiene motivos seleccionables                   
            return this.entradaService.getDescuentos(this.currentEntrada.entrada.GrupoMotivoId);            
                
            // if (entrada.TipoProducto === '2') {
            //   let motivoId = 0;
            //   entrada.PromocionEntradas.array.forEach(element => {
            //     if (element.GrupoMotivoId != '') {
            //       motivoId = element.GrupoMotivoId;
            //     }
            //   });
            //   return this.entradaService.getDescuentos(motivoId);
            // } else {
            //   return this.entradaService.getDescuentos(this.currentEntrada.entrada.GrupoMotivoId);
            // }

            // Yaribel 20210504  Se ha modificado el codigo para indicar GrupoMotivoId tanto en entradas como en promociones y solo tiene valor si tiene motivos seleccionables >>

          } else {
            return of(entrada);
          }
        })
      )
      .pipe(
        mergeMap(res => {
          if (this.currentEntrada) {
            return this.motivosService
              .getMotivosSeleccionadosByEntradaId(this.currentEntrada.entrada.TipoEntradaId)
              .pipe(
                map(motivosSeleccionados => {
                  if (motivosSeleccionados) {
                    this.listaMotivosSeleccionados = motivosSeleccionados.lista;
                  }
                  return res;
                })
              );
          } else {
            return of(res);
          }
        })
      )
      .pipe(takeWhile(() => this.alive))
      .subscribe(motivos => {
        this.motivos = motivos;
      });
    this.element.style.display = 'block';
    document.body.classList.add('jw-modal-open');
  }

  close(): void {
    this.alive = false;
    this.element.style.display = 'none';
    document.body.classList.remove('jw-modal-open');
  }

  forwardEntrada(entrada) {
    this.entradas.indexOf(linea => linea.entrada.TipoProductoId === entrada.TipoProductoId);
  }

  backEntrada() {}

  getPrecioTotal() {
    return this.motivosService.getPrecioTotal();
  }

  getCantidadTotal() {
    return this.motivosService.getCantidadTotal();
  }

  selectMotivo(motivo) {
    this.motivoSeleccionado = motivo;
    this.motivoSeleccionado.idEntradaAsociada = this.currentEntrada.entrada.TipoEntradaId;
    // this.entrada.motivos.push(motivo);
    const input = document.getElementById(`motivo-${this.motivoSeleccionado.PkId}`);
    this.motivoPadService.selected = input;
    this.motivoPadService.motivo = this.motivoSeleccionado;
    this.formControlService.setCurrentFormGroup(null, input, input.getAttribute('category'));
    // tslint:disable-next-line: deprecation
    if ((<HTMLElement>event.target).getAttribute('category') === 'MOTIVO') {
      this.numpadService.commaDisabled = true;
    } else {
      this.numpadService.commaDisabled = false;
    }
  }

  getCantidadPorMotivo(id) {
    if (this.listaMotivosSeleccionados) {
      return this.listaMotivosSeleccionados.find(m => m.PkId === id)
        ? this.listaMotivosSeleccionados.find(m => m.PkId === id).numMotivo
        : '';
    } else {
      return '';
    }
  }

  eliminarMotivo(motivo) {
    const oldVals = {
      motivoSeleccionado: this.motivoPadService.motivo,
      selected: this.motivoPadService.selected
    };
    this.motivoSeleccionado = motivo;
    this.motivoSeleccionado.idEntradaAsociada = this.currentEntrada.entrada.TipoEntradaId;
    const input = document.getElementById(`motivo-${this.motivoSeleccionado.PkId}`);
    this.motivoPadService.selected = input;
    this.motivoPadService.motivo = this.motivoSeleccionado;
    this.formControlService.setCurrentFormGroup(null, input, input.getAttribute('category'));
    this.formControlService.setToBlank();

    if (oldVals.motivoSeleccionado) {
      this.motivoSeleccionado = oldVals.motivoSeleccionado;
    }
    if (oldVals.selected) {
      this.motivoPadService.selected = oldVals.selected;
    }

    this.motivoPadService.motivo = this.motivoSeleccionado;
    this.formControlService.setCurrentFormGroup(
      null,
      this.motivoPadService.selected,
      this.motivoPadService.selected.getAttribute('category')
    );
    // this.numpadService.entrada = entradaOriginal;
  }

  focusValue(event: FocusEvent, motivo: any) {
    this.motivoSeleccionado = motivo;
    const target = event.target as HTMLInputElement;
    const category = target.getAttribute('category');

    this.motivoPadService.selected = target;
    this.motivoPadService.motivo = motivo;
    this.formControlService.setCurrentFormGroup(
      null,
      target,
      category
    );
  }

  unfocusValue(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    if (target.value === '') {
      this.motivoPadService.setNumpadOrder('reset');
      return;
    }
  }

  onInputChange(event: Event, motivo: any) {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const cantidad = value === '' || value === null || value === undefined ? 0 : parseInt(value, 10) || 0;
    
    // Actualizar el estado interno de motivos cuando cambia el input
    this.motivosService.pushMotivo(motivo, cantidad);
  }

  inputDeTeclado(event: KeyboardEvent, motivo: any) {
    event.preventDefault();
    const key = event.key;
    
    // Configurar el motivo seleccionado
    this.motivoSeleccionado = motivo;
    this.motivoSeleccionado.idEntradaAsociada = this.currentEntrada.entrada.TipoEntradaId;
    
    const target = event.target as HTMLInputElement;
    
    // Asegurar que el category y data-motivo-pk-id estén configurados
    if (target.getAttribute('category') !== 'MOTIVO') {
      target.setAttribute('category', 'MOTIVO');
    }
    if (!target.getAttribute('data-motivo-pk-id')) {
      target.setAttribute('data-motivo-pk-id', motivo.PkId);
    }
    
    // Configurar motivoPadService
    this.motivoPadService.selected = target;
    this.motivoPadService.motivo = this.motivoSeleccionado;
    
    // Configurar FormControl
    this.formControlService.setCurrentFormGroup(
      null,
      target,
      'MOTIVO'
    );
    
    // Manejar teclas especiales
    if (this.isDeleteButtonPressed(key)) {
      this.formControlService.deleteChar();
      return;
    }
    
    if (this.isEnterButton(key)) {
      this.formControlService.unfocus();
      target.blur();
      return;
    }
    
    // Manejar números
    if (this.isNumberKey(key)) {
      this.formControlService.inputChar(key);
      return;
    }
  }

  isNumberKey(key: string): boolean {
    return /^[0-9]$/.test(key);
  }

  isDeleteButtonPressed(key: string): boolean {
    return key === 'Backspace';
  }

  isEnterButton(key: string): boolean {
    return key === 'Enter';
  }

  agregarMotivosLocalizador() {
    if (this.getCantidadTotal() > this.currentEntrada.cantidad) {
      this.toast.error('', this.translate.instant('ERROR_MOTIVOS_CANTIDAD'), {
        toastComponent: ErrorToast,
        timeOut: 5000
      });
      return;
    }
    const listaFarMotivos = this.motivosService.motivosSeleccionadosValue.map(motivo => {
      return {
        FarId: this.entradaService.entradaSeleccionada.FarId,
        ListaMotivos: motivo.lista.map(motivoDetalle => {
          return { MotivoId: motivoDetalle.PkId, Cantidad: motivoDetalle.numMotivo };
        })
      };
    });
    this.localizadorService.insertarMotivos(listaFarMotivos).subscribe(res => {
      this.close();
    });
  }
}
